import React, { useEffect, useState } from "react";
import {
  getDocs,
  collection,
  query,
  where,
  orderBy,
} from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { db } from "../../config/firebaseConfig";
import "./MasterList.css";

const MasterList = () => {
  const [deviceData, setDeviceData] = useState([]);
  const [filterText, setFilterText] = useState("");
  const [selectedMasterID, setSelectedMasterID] = useState(null);
  const navigate = useNavigate();
  const currentProjectID = localStorage.getItem("currentProjectID");
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc"); // or "desc"


  const fields = [
    "masterID",
    "name",
    "maker",
    "user",
    "updatedBy",
    "ModifiedDate",
    "remark1",
    "fileLinks",
  ];

  const fieldLabels = {
    masterID: "マスターID",
    name: "名称",
    maker: "メーカー",
    user: "担当者",
    updatedBy: "最終更新者",
    ModifiedDate: "更新日",
    remark1: "備考1",
    fileLinks: "関連ファイル",
  };

  // 各masterIDごとの files サブコレクションからファイル情報取得
  const fetchFileLinks = async (masterID) => {
    const fileSnapshot = await getDocs(
      collection(db, "projects", currentProjectID, "masters", masterID, "files")
    );
    const files = fileSnapshot.docs.map((doc) => doc.data());
    // 複数ファイルを <a>タグで配列にして返す
    return files.map((f) => ({
      fileName: f.fileName,
      downloadURL: f.downloadURL,
    }));
  };

  const fetchData = async () => {
    if (!currentProjectID) {
      console.warn("currentProjectID が未設定です");
      return;
    }

    const q = query(
      collection(db, "00_DeviceMasterTable"),
      where("projectID", "==", currentProjectID),
      orderBy("sortIndex")
    );

    const snapshot = await getDocs(q);
    const rawData = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

    const dataWithFiles = await Promise.all(
      rawData.map(async (item) => {
        const fileLinks = await fetchFileLinks(item.masterID);
        return { ...item, fileLinks };
      })
    );

    setDeviceData(dataWithFiles);
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, []);



  const filteredData = deviceData.filter((item) =>
    item.name?.toLowerCase().includes(filterText.toLowerCase())
  );


  const handleRowClick = (masterID) => {
    setSelectedMasterID(masterID);
  };

  const handleEditClick = () => {
    if (selectedMasterID) {
      navigate(`/EditMaster/${selectedMasterID}`);
    } else {
      alert("編集する行を選択してください");
    }
  };

// ソート関数
  const sortedData = [...filteredData].sort((a, b) => {
    if (!sortField) return 0;
    const valA = a[sortField] ?? "";
    const valB = b[sortField] ?? "";

    if (valA < valB) return sortOrder === "asc" ? -1 : 1;
    if (valA > valB) return sortOrder === "asc" ? 1 : -1;
    return 0;
  });


  return (
    <div className="device-master-list">
      <h2>📋 マスター情報 一覧</h2>

      <div className="top-controls">
        <input
          type="text"
          placeholder="名称でフィルター"
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
        />
        <button onClick={handleEditClick}>編集</button>
      </div>

      <table className="device-table">
      {/* thead */}
        <thead>
          <tr>
            {fields.map((field) => (
              <th
                key={field}
                onClick={() => {
                  if (sortField === field) {
                    setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
                  } else {
                    setSortField(field);
                    setSortOrder("asc");
                  }
                }}
              >
                {fieldLabels[field] || field}
                {sortField === field && (
                  <span className="sort-icon">{sortOrder === "asc" ? "▲" : "▼"}</span>
                )}
              </th>
            ))}
          </tr>
        </thead>
      {/* tbody */}
        <tbody>
          {sortedData.map((item) => (
            <tr
              key={item.id}
              className={selectedMasterID === item.masterID ? "selected" : ""}
              onClick={() => handleRowClick(item.masterID)}
            >
              {fields.map((field) => (
                <td key={field}>
                  {field === "fileLinks" ? (
                    item.fileLinks && item.fileLinks.length > 0 ? (
                      <ul className="file-link-list">
                        {item.fileLinks.map((file, index) => (
                          <li key={index}>
                            <a href={file.downloadURL} target="_blank" rel="noopener noreferrer">
                              {file.fileName}
                            </a>
                          </li>
                        ))}
                      </ul>
                    ) : (
                      "-"
                    )
                  ) : (
                    item[field] ?? ""
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>

      </table>
    </div>
  );
};

export default MasterList;
